import Dispatch from "nexia_mobile/flux_like/dispatch";
import { setValueAtPath } from "nexia_mobile/flux_like/store";

Dispatch.on("VIDEO_PLAYER_VISIBLE", () => {
  setValueAtPath("isPlayingVideo", true);
});

Dispatch.on("VIDEO_PLAYER_NOT_VISIBLE", () => {
  setValueAtPath("isPlayingVideo", false);
});



// WEBPACK FOOTER //
// ./src/flux_like/action_handlers/video.js